import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

const CheckboxWrapper = ({
  children, gap = '8px', className = '', disabled, id, TypeElement = 'label',
}) => (
  <TypeElement
    htmlFor={id}
    className={cx('checkbox-wrapper', { disabled }, className)}
    style={{ gap }}
  >
    {children}
  </TypeElement>
);

CheckboxWrapper.propTypes = {
  children: T.node,
  gap: T.oneOfType([T.string, T.number]),
  id: T.oneOfType([T.string, T.number]),
  disabled: T.bool,
  className: T.oneOfType([T.string, T.func]),
  TypeElement: T.string,
};
export default CheckboxWrapper;
